<template lang="pug">
#WellnessChallengeHeader
  .level.challenge-header
    .level-left
      .level-item
        .challenge-header-title-container
          .challenge-header-title.is-flex.is-flex-direction-column
            .is-size-4.has-text-grey
              span Wellness Challenge
              RouterLink.pl-2(
                v-if="showChallengeEditButton"
                :to="{ name: editChallengeRoute, params: { challengeId } }"
              )
                BIcon(icon="settings" size="is-small")
            .is-flex
              WtTitle.mb-1(h1 v-if="!_.isEmpty(challenge)") {{ challenge.name }}
              ChallengeJoinButton(:challenge="challenge")
            .is-flex.is-flex-wrap-nowrap.is-align-items-center(v-if="!_.isEmpty(challenge) && ! challenge.incentivesOn")
              .challenge-details
                a.has-text-underlined.is-flex-grow-1(
                  href="#"
                  @click.prevent="showChallengeDetails = !showChallengeDetails"
                ) About This Challenge

    .level-right
      .level-item
        WtButton(isRouterLink to="/challenges" color="primary") BACK TO ALL CHALLENGES
  .level
    .level-left
      .level-item(v-if="!_.isEmpty(challenge) && challenge.incentivesOn")
        ChallengeTerryberryAwardPoints(
          :challenge="challenge"
          @showChallengeDetails="showChallengeDetails = $event"
          @awardPointsDescription="awardPointsDescription = $event"
        )
      .level-item
        div.pr-5
          .is-size-6.has-text-grey Start Date
          .is-size-5 {{ challengeStartDate(challenge) }}
        div.pr-5
          .is-size-6.has-text-grey End Date
          .is-size-5 {{ challengeEndDate(challenge) }}
        div.pr-5
          .is-size-6.has-text-grey Goal
          .is-size-5 {{ pointsGoal }}
        div.pl-4(v-if="isTodayBeforeChallengeStart(challenge)")
          span.is-size-3.has-text-danger.mr-2 {{ daysTillChallengeStart(challenge) }}
          span.is-size-5.has-text-grey days till Start
        div.pl-4(v-if="!isTodayBeforeChallengeStart(challenge) && !isTodayAfterChallengeEnd(challenge)")
          span.is-size-3.has-text-danger.mr-2 {{ daysRemainingInChallenge(challenge) }}
          span.is-size-5.has-text-grey {{ daysRemainingInChallengeText(challenge) }}
        div.pl-4(v-if="isTodayAfterChallengeEnd(challenge)")
          span.is-size-3.has-text-danger.mr-2 {{ daysTillTallyText(challenge) }}

  // DETAILS MODAL
  BModal.details-modal(
    :active.sync="showChallengeDetails"
    has-modal-card
  )
    .modal-card(style="width: auto")
      section.modal-card-body.modal-card-body-no-head-no-foot
        WtTitle(h3) About This Challenge
        WtIconButton.close-button(@click.native="showChallengeDetails = false" aria-label="Close modal")
          BIcon(icon="close-circle" type="is-grey-light" size="is-medium")
        .mb-3.p-3.has-background-light.has-border-radius-large(v-if="!_.isEmpty(challenge) && challenge.incentivesOn")
          .is-size-5.has-text-weight-bold Award Points:
            span.pl-1.has-text-weight-light This challenge has Award Points.  These points can be exchanged for items.  
            span.pl-1.has-text-weight-light {{ awardPointsDescription }}
        .pt-2
          .is-size-5.has-text-weight-bold Total Potential Challenge Points:
            span.pl-1.has-text-weight-light {{ challenge.totalPointsPossible}}
          .is-size-5.has-text-weight-bold Total Challenge Points Needed to Reach Challenge Goal:
            span.pl-1.has-text-weight-light {{ challenge.totalPointsGoal }}
        WtDisplayRichTextHTML.pt-4.pb-4(:html="challenge.map.description")
        .p-3.has-background-light.has-border-radius-large
          WtTitle(card-title) How to Earn Points in {{ challenge.name }}
          WellnessChallengePointsBreakDownDetails(
            :metricsTracking="challenge.metricsTracking"
            :isCustomWellness="Boolean(challenge.isCustomWellness)"
          )

</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import { challengeMixin } from "@/mixins/challengeMixin";
import WtDisplayRichTextHTML from "@@/WtDisplayRichTextHTML/WtDisplayRichTextHTML";
import WtButton from "@@/WtButton/WtButton";
import WtIconButton from "@@/WtIconButton/WtIconButton";
import WtTile from "@@/WtTile/WtTile";
import WtTitle from "@@/WtTitle/WtTitle";
import ChallengeJoinButton from "@@/Challenge/ChallengeJoinButton";
import WellnessChallengePointsBreakDownDetails from "@@/Challenge/WellnessChallenge/WellnessChallengePointsBreakDownDetails";
import ChallengeTerryberryAwardPoints from "@@/Challenge/ChallengeTerryberryAwardPoints";

export default {
  name: "WellnessChallengeHeader",
  components: {
    WtDisplayRichTextHTML,
    WtButton,
    WtIconButton,
    WtTile,
    WtTitle,
    ChallengeJoinButton,
    WellnessChallengePointsBreakDownDetails,
    ChallengeTerryberryAwardPoints
  },

  mixins: [dateUtilityMixin, challengeMixin],

  data() {
    return {
      showChallengeDetails: false,
      awardPointsDescription: ""
    };
  },

  computed: {
    ...mapGetters("pages", ["isPageLoaded", "isPageLoading"]),
    ...mapGetters("challenges", ["joining", "getChallengeById"]),
    ...mapGetters("members", ["challenges"]),
    ...mapGetters("program", ["coreProgramMeta"]),

    showChallengeEditButton() {
      if (this._.isEmpty(this.challenge)) return false;
      if (this.challenge.isPvsPChallenge) return false;

      let isAdmin =
        this.challenge.initiator.id === this.$auth.user().id ||
        this.$auth.user().isAdmin;

      return isAdmin;
    },

    editChallengeRoute() {
      return this.$auth.user().isAdmin
        ? "ChallengeEditAdmin"
        : "ChallengeEditMember";
    },

    page() {
      return `Challenge${this.challengeId}`;
    },

    challengeId() {
      return this.$route.params.challengeId;
    },

    challenge() {
      return this.getChallengeById(this.challengeId);
    },

    fullPageLoader() {
      // since there is no intial state for 'isPageLoading(this.page)'
      if (this._.isUndefined(this.isPageLoading(this.page))) {
        return true;
      }
      return this.isPageLoading(this.page);
    },

    isCompleted() {
      const COMPLETED = 2;
      return (
        this.getChallengeById(this.$route.params.challengeId).status ===
        COMPLETED
      );
    },

    thisMembersPoints() {
      const leaderboard = this.getLeaderboardById(this.challengeId);
      const member = leaderboard.find(member => {
        return member.id === this.$auth.user().id;
      });
      return member ? member.points : null;
    },

    pointsGoal() {
      return this.challenge.totalPointsGoal;
    }
  },

  methods: {
    ...mapActions("pages", ["setPageLoaded", "setPageLoading"]),
    ...mapActions(["snackBar"]),

    isMetricOn(metric) {
      return this.challenge.metricsTracking[metric];
    }
  }
};
</script>

<style lang="sass" scoped>
#WellnessChallengeHeader
  width: 100%
  .challenge-details
    position: relative
  .challenge-header
    width: 100%
    .column
      padding-left: 0
    .challenge-header-title
      margin-bottom: .5rem
    .level-item
      justify-content: flex-start
  .back-button
    position: relative
  .details-modal
    .close-button
      position: absolute
      top: .5rem
      right: .5rem
    .modal-card-body.modal-card-body-no-head-no-foot
      border-radius: $radius-large
    .modal-card-head, .modal-card-foot
      padding: .5rem
</style>
